export const STATUS_NOTIFICATION_DEFAULT = null;
export const STATUS_NOTIFICATION_SUCCESS = 'success';
export const STATUS_NOTIFICATION_FAILURE = 'failure';
